import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

import { NavigationService } from '../services/navigation.service';
import { DropdownComponent } from '../ui';
import { ButtonComponent } from '../ui/button/button.component';

@Component({
  selector: 'app-navigation-controls',
  imports: [CommonModule, DropdownComponent, ButtonComponent, TranslocoPipe],
  templateUrl: './navigation-controls.component.html',
  styleUrls: ['./navigation-controls.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationControlsComponent {
  private navigation = inject(NavigationService);

  showHelp = signal(false);
  showNavigation = signal(false);
  showViewPresets = signal(false);

  get currentNavigationMode(): string {
    return this.navigation.navigationMode();
  }
  get navigationModeOptions() {
    return this.navigation.getNavigationModeOptions();
  }

  fitToScreen(): void {
    this.navigation.fitToScreen();
  }

  zoomIn(): void {
    this.navigation.zoomIn();
  }

  zoomOut(): void {
    this.navigation.zoomOut();
  }

  tiltUp(): void {
    this.navigation.tiltUp();
  }

  tiltDown(): void {
    this.navigation.tiltDown();
  }

  rotateClockwise(): void {
    this.navigation.rotateClockwise();
  }

  rotateCounterClockwise(): void {
    this.navigation.rotateCounterClockwise();
  }

  toggleHelp(): void {
    this.showHelp.update(v => !v);
    if (this.showHelp()) {
      this.showNavigation.set(false);
      this.showViewPresets.set(false);
    }
  }

  toggleNavigation(): void {
    this.showNavigation.update(v => !v);
    if (this.showNavigation()) {
      this.showHelp.set(false);
      this.showViewPresets.set(false);
    }
  }

  toggleViewPresets(): void {
    this.showViewPresets.update(v => !v);
    if (this.showViewPresets()) {
      this.showHelp.set(false);
      this.showNavigation.set(false);
    }
  }

  onNavigationModeChange(m: string): void {
    this.navigation.navigationMode.set(m);
  }

  setTopView(): void {
    this.navigation.setTopView();
  }

  setBottomView(): void {
    this.navigation.setBottomView();
  }

  setFrontView(): void {
    this.navigation.setFrontView();
  }

  setBackView(): void {
    this.navigation.setBackView();
  }

  setLeftView(): void {
    this.navigation.setLeftView();
  }

  setRightView(): void {
    this.navigation.setRightView();
  }
}
